import { createRouter, createWebHashHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import TabsPage from '../views/TabsPage.vue';

/* eslint-disable */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/tabs/duate'
  },
  {
    path: '/duate/:titulli',
    component: () => import('@/views/Content.vue')
  },
  {
    path: '/tabs',
    component: TabsPage,
    children: [
      {
        path: '',
        redirect: '/tabs/duate'
      },
      {
        path: 'duate',
        component: () => import('@/views/Duas.vue')
      },
      {
        path: 'te-preferuarat',
        component: () => import('@/views/Favourites.vue')
      },
      {
        path: 'info',
        component: () => import('@/views/Info.vue')
      },
      {
        path: 'feedback',
        component: () => import('@/views/Feedback.vue')
      },
    ]
  },
  // Catch-all route to prevent 404 errors
  {
    path: '/:pathMatch(.*)*',
    redirect: '/tabs/duate'
  }
];

// Use hash mode to avoid 404 issues on refresh
const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
